import { render, staticRenderFns } from "./siteInfoIndex.vue?vue&type=template&id=68805e43"
import script from "./siteInfoIndex.vue?vue&type=script&lang=js"
export * from "./siteInfoIndex.vue?vue&type=script&lang=js"
import style0 from "./siteInfoIndex.vue?vue&type=style&index=0&id=68805e43&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports